// extracted by mini-css-extract-plugin
export var backgroundImage = "ConditionsReverse-module--backgroundImage--elGAE";
export var card = "ConditionsReverse-module--card--5K1J7";
export var cardArrow = "ConditionsReverse-module--cardArrow--FESRh";
export var cardBack = "ConditionsReverse-module--cardBack--Fp88V";
export var cardBackContent = "ConditionsReverse-module--cardBackContent--djlkM";
export var cardBackDescription = "ConditionsReverse-module--cardBackDescription--ikeEP";
export var cardBackFooter = "ConditionsReverse-module--cardBackFooter--bCfKA";
export var cardBackTitle = "ConditionsReverse-module--cardBackTitle--38Pi0";
export var cardBackground = "ConditionsReverse-module--cardBackground--agxoU";
export var cardContainer = "ConditionsReverse-module--cardContainer--BaF04";
export var cardContent = "ConditionsReverse-module--cardContent--uP1p9";
export var cardCta = "ConditionsReverse-module--cardCta--6v0TO";
export var cardFront = "ConditionsReverse-module--cardFront--51KQb";
export var cardIcon = "ConditionsReverse-module--cardIcon--8SHco";
export var cardSubtitle = "ConditionsReverse-module--cardSubtitle--4VDMy";
export var cardTextContent = "ConditionsReverse-module--cardTextContent--hEIKg";
export var cardTitle = "ConditionsReverse-module--cardTitle--jwbPG";
export var cardsGrid = "ConditionsReverse-module--cardsGrid--u6NHI";
export var conditionsWrapper = "ConditionsReverse-module--conditionsWrapper--GME2-";
export var diabetesCard = "ConditionsReverse-module--diabetesCard--BEs6a";
export var fattyLiverCard = "ConditionsReverse-module--fattyLiverCard--ybFnK";
export var flipped = "ConditionsReverse-module--flipped--SPb6Q";
export var hypertensionBg = "ConditionsReverse-module--hypertensionBg--iADq6";
export var hypertensionCard = "ConditionsReverse-module--hypertensionCard--UxSn3";
export var obesityBg = "ConditionsReverse-module--obesityBg--krYMO";
export var obesityCard = "ConditionsReverse-module--obesityCard--uE+CD";
export var pcosBackground = "ConditionsReverse-module--pcosBackground--in6eY";
export var pcosCard = "ConditionsReverse-module--pcosCard--p5ZXa";
export var pcosContent = "ConditionsReverse-module--pcosContent--L5gfo";
export var sectionDescription = "ConditionsReverse-module--sectionDescription--Ravjz";
export var sectionHeader = "ConditionsReverse-module--sectionHeader--rVGZG";
export var sectionTitle = "ConditionsReverse-module--sectionTitle--sURH5";